import React, { useCallback } from 'react';
import {
  CacheProvider,
  createGenerateClassName,
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  StylesProvider,
  ThemeProvider,
} from '@quillbot/design-system';
import { darkMode, herokuapp, litcharts, theme } from '../../config/theme';
import { useCoreSelector } from '../redux';
import { useRouter } from 'next/router';

const themeObj: {
  [key: string]: any;
} = {
  default: theme,
  dark: darkMode,
  litcharts: litcharts,
  herokuapp: herokuapp,
};

export const CoreThemeProvider = ({ emotionCache, children }: any) => {
  const themeName = useCoreSelector((rootState: any) => rootState?.common?.theme);
  const router = useRouter();

  const pagesWithNoSupportForDarkMode = [
    '/citation-generator',
    '/co-writer',
    '/extension-success',
    '/exit-survey',
    '/guides/paraphrasing',
    '/guides/ai-writing-assistant',
    '/plagiarism-checker',
    '/expert-review',
    '/cookie-policy',
    '/ambassador',
  ];

  const getTheme = useCallback(
    (theme: string) => {
      let requiredTheme = themeObj.default;
      if (pagesWithNoSupportForDarkMode.includes(router.pathname)) {
        requiredTheme = themeObj.default;
        if (theme === 'dark') {
          return createTheme(requiredTheme);
        }
      }
      if (themeObj[theme]) {
        requiredTheme = themeObj[theme];
      }
      return createTheme(requiredTheme);
    },
    [themeName, router.pathname]
  );

  return (
    <StyledEngineProvider injectFirst>
      <StylesProvider generateClassName={generateClassName}>
        <CacheProvider value={emotionCache}>
          <ThemeProvider theme={getTheme(themeName)}>
            <CssBaseline />
            {children}
          </ThemeProvider>
        </CacheProvider>
      </StylesProvider>
    </StyledEngineProvider>
  );
};

const generateClassName = createGenerateClassName({
  disableGlobal: true,
  seed: 'mf',
});
